'use strict';
import $ from 'jquery';
// TODO: (@mbenin) look into using es6-promise (lighter)

export default function (url, options = {}) {
    return new Promise(function (resolve, reject) {
        options.success = function (data) {
            resolve(data);
        };

        options.error = function (jqXHR, status, error) {
            reject([jqXHR, status, error]);
        };

        $.ajax(url, options);
    });
}
